import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

import { AddProfessionalReviewCandidate } from "../../../types/addReviewCandidate";

import RatingTable from "../RatingTable";

const CommunicationLeadershipStep = () => {
  const { t } = useTranslation("goHire", { keyPrefix: "components.reviewCandidateModal" });
  const { t: tProfReport } = useTranslation("goHire", {
    keyPrefix: "components.reviewCandidateModal.professionalReport",
  });

  const { control } = useFormContext<AddProfessionalReviewCandidate>();

  const skills: { title: string; description: string; fieldName: keyof AddProfessionalReviewCandidate }[] = [
    {
      title: tProfReport("leadership"),
      description: tProfReport("abilityToInspireOrganizeGuide"),
      fieldName: "leadership",
    },
    {
      title: tProfReport("communicationClarity"),
      description: tProfReport("effectivenessInDeliveringInstructions"),
      fieldName: "communicationClarity",
    },
    {
      title: tProfReport("teamManagement"),
      description: tProfReport("skillInManagingGroupDynamics"),
      fieldName: "teamManagement",
    },
    {
      title: tProfReport("influenceNetworking"),
      description: tProfReport("strengthOfRelationships"),
      fieldName: "influenceNetworking",
    },
    {
      title: tProfReport("culturalAdaptability"),
      description: tProfReport("abilityToWorkAcrossDiverseEnvironments"),
      fieldName: "culturalAdaptability",
    },
  ];

  return (
    <Box sx={[styles.container, styles.containerPadding]}>
      <RatingTable ratings={skills} control={control} />
    </Box>
  );
};

export default CommunicationLeadershipStep;

const styles = {
  containerPadding: {
    px: "24px",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
};
